import { ShareOutlined } from "@mui/icons-material";
import { Button } from "@mui/material";
import { enqueueSnackbar } from "notistack";
import { SnackbarContent } from "src/components";

interface Props {
  variant: "outlined" | "tertiary";
  href: string;
}

const ShareButton = ({ variant, href }: Props) => {
  function handleShareClicked() {
    navigator.clipboard.writeText(href);
    enqueueSnackbar(<SnackbarContent title="Success" content="The link has been copied to the clipboard." />, {
      variant: "success",
    });
  }

  if (variant === "tertiary") {
    return (
      <Button variant="tertiary" startIcon={<ShareOutlined />} onClick={handleShareClicked}>
        Share
      </Button>
    );
  }

  if (variant === "outlined") {
    return (
      <Button variant="outlined" startIcon={<ShareOutlined />} onClick={handleShareClicked}>
        Share
      </Button>
    );
  }

  return null;
};

export { ShareButton };
